import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { PostalCodePatternMaskProps } from '../FormPostalCode.types';

export const PostalCodePatternMask = forwardRef<HTMLInputElement, PostalCodePatternMaskProps>(({ onChange, ...props }, ref) => {
    /**
     * This handles the callback to our input element onChange.
     * We have to construct a psuedo change event manually to pass it to the
     * input element onChange.
     */
    const handleAccept = (value: string, masked: any) => {
        if (onChange) {
            const event = {
                ...masked.el,
                target: {
                    ...masked.el,
                    value: value,
                    selectionEnd: masked._selection.end,
                },
            };

            onChange(event as React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>);
        }
    };

    return (
        <IMaskInput
            {...props}
            mask={'### ###'}
            definitions={{
                '#': /[\dA-Za-z]/,
            }}
            inputRef={ref}
            onAccept={handleAccept}
        />
    );
});